import { createApi } from '@reduxjs/toolkit/query/react';
import { salaryBaseQuery } from '../../lib/axiosBaseQuery';
import { IAddBeneficiaryReqData } from '../../types/index';

export const employeesApi = createApi({
  reducerPath: 'employeesApi',
  baseQuery: salaryBaseQuery,
  tagTypes: ['Employees', 'EmployeeDetails'],
  endpoints: (builder) => ({
    getEmployeesList: builder.query<any, void>({
      query: () => ({
        url: 'Beneficiary/list',
        method: 'GET',
      }),
      providesTags: ['Employees'],
    }),
    getEmployeeDetails: builder.query<any, string>({
      query: (id) => ({
        url: `Beneficiary/${id}/details`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'EmployeeDetails', id }],
    }),
    addEmployee: builder.mutation<any, IAddBeneficiaryReqData>({
      query: (data) => ({
        url: 'Beneficiary/add',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Employees'],
    }),
    deleteEmployeeList: builder.mutation<any, string>({
      query: (id) => ({
        url: `Beneficiary/remove/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Employees'],
    }),
    deleteEmployeeItem: builder.mutation<any, string>({
      query: (id) => ({
        url: `Beneficiary/item/${id}/remove`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Employees', 'EmployeeDetails'],
    }),
    updateEmployee: builder.mutation<any, any>({
      query: (data) => ({
        url: 'Beneficiary/update',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Employees', 'EmployeeDetails'],
    }),
  }),
});

export const {
  useGetEmployeesListQuery,
  useGetEmployeeDetailsQuery,
  useLazyGetEmployeeDetailsQuery,
  useAddEmployeeMutation,
  useDeleteEmployeeListMutation,
  useDeleteEmployeeItemMutation,
  useUpdateEmployeeMutation,
} = employeesApi;
